<template>
  <div>
    <div class="lg:grid lg:grid-cols-3 gap-[25px]">
      <div class="lg:col-span-2">
        <WelcomeDashboard />

        <TotalSalesChart />
      </div>
      <div class="lg:col-span-1">
        <TotalOrdersChart />

        <TotalCustomersChart />

        <TotalRevenueChart />
      </div>
    </div>

    <div class="lg:grid lg:grid-cols-5 gap-[25px]">
      <div class="lg:col-span-2">
        <SalesByLocations />
      </div>
      <div class="lg:col-span-3">
        <TopSellingProducts />
      </div>
    </div>

    <div class="lg:grid lg:grid-cols-1 gap-[25px]">
      <div class="lg:col-span-1">
        <RecentOrders />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import WelcomeDashboard from "@/components/Dashboard/Ecommerce/WelcomeDashboard.vue";
import TotalSalesChart from "@/components/Dashboard/Ecommerce/TotalSalesChart.vue";
import TotalOrdersChart from "@/components/Dashboard/Ecommerce/TotalOrdersChart.vue";
import TotalCustomersChart from "@/components/Dashboard/Ecommerce/TotalCustomersChart.vue";
import TotalRevenueChart from "@/components/Dashboard/Ecommerce/TotalRevenueChart.vue";
import SalesByLocations from "@/components/Dashboard/Ecommerce/SalesByLocations.vue";
import TopSellingProducts from "@/components/Dashboard/Ecommerce/TopSellingProducts.vue";
import RecentOrders from "@/components/Dashboard/Ecommerce/RecentOrders.vue";

export default defineComponent({
  name: "EcommercePage",
  components: {
    WelcomeDashboard,
    TotalSalesChart,
    TotalOrdersChart,
    TotalCustomersChart,
    TotalRevenueChart,
    SalesByLocations,
    TopSellingProducts,
    RecentOrders,
  },
});
</script>
